const extensions = {
  Image: ['jpg', 'jpeg', 'png', 'webp', 'bmp'],
  Video: ['mp4', 'mov', 'webm', 'avi', 'mkv'],
  Audio: ['mp3', 'wav', 'aac', 'flac', 'm4a', 'ogg']
}
export const assetUploadAccept = Object.values(extensions).flat().map(ext => `.${ext}`).join(',')
export function assetUploadType(name) {
  const ext = String(name).split('.').pop().toLowerCase()
  return Object.keys(extensions).find(type => extensions[type].includes(ext)) || ''
}
export function assetUploadFileError(file) {
  const type = assetUploadType(file.name)
  if (!type) return '不支持的文件格式'
  const limit = type === 'Image' ? 15 : 500
  return file.size > limit * 1024 * 1024 ? `超过 ${limit}MB` : ''
}
export function assetUploadFileKey(file) {
  return JSON.stringify([file.webkitRelativePath || file.name, file.size, file.lastModified])
}
export function assetUploadDuration(file, type) {
  if (type === 'Image') return Promise.resolve(null)
  return new Promise(resolve => {
    const url = URL.createObjectURL(file)
    const media = document.createElement(type === 'Audio' ? 'audio' : 'video')
    const finish = value => {
      clearTimeout(timer)
      media.onloadedmetadata = null
      media.onerror = null
      media.removeAttribute('src')
      media.load()
      URL.revokeObjectURL(url)
      resolve(value)
    }
    const timer = setTimeout(() => finish(null), 10000)
    media.preload = 'metadata'
    media.onloadedmetadata = () => finish(Number.isFinite(media.duration) ? Math.round(media.duration * 1000) : null)
    media.onerror = () => finish(null)
    media.src = url
  })
}
